import { AssertionError } from 'assert';

/**
 * Fluently , // "流暢に使用できる",
 * CanBeUsed ,//"だいたい使用できる",
 * HardlyUsable, // "ほとんど使用できない",
 * CanNot , // "できない",
 * DoNotWantTo ,// "したくない",
 */
export type CommunicationMethod = 'Fluently' | 'CanBeUsed' | 'HardlyUsable' | 'CanNot' | 'DoNotWantTo';

export function methodValueToJa(value: CommunicationMethod): string {
  switch (value) {
    case 'Fluently':
      return '流暢に使用できる';
    case 'CanBeUsed':
      return 'だいたい使用できる';
    case 'HardlyUsable':
      return 'ほとんど使用できない';
    case 'CanNot':
      return 'できない';
    case 'DoNotWantTo':
      return 'したくない';
    default:
      return '';
  }
}

function priorityComminicationMethod(method: CommunicationMethod): number {
  switch (method) {
    case 'Fluently':
      return 5;
    case 'CanBeUsed':
      return 4;
    case 'HardlyUsable':
      return 3;
    case 'CanNot':
      return 2;
    case 'DoNotWantTo':
      return 1;
    default:
      return 0;
  }
}

/**
 * Listener, // 聴者
 * HardHearing , // 難聴者
 * Deaf , // ろう者
 */
export type Deafness = 'Listener' | 'HardHearing' | 'Deaf';
export function getDeafNessName(deffness: Deafness) {
  switch (deffness) {
    case 'Listener':
      return '聴者';
    case 'HardHearing':
      return '難聴者';
    case 'Deaf':
      return 'ろう者';
  }
}
export const deffnessOptions = [
  { value: 'Listener', title: '聴者' },
  { value: 'HardHearing', title: '難聴者' },
  { value: 'Deaf', title: 'ろう者' },
];

export type ActorTypeNames = 'MultiDeaf' | 'IdenDeaf' | 'CorrespondingHardHearing' | 'IdenHardHearing' | 'MultiListener' | 'CorrespondingListener' | 'Listener';

/**日本手話 */
type SignLanguage = CommunicationMethod;
/** 日本語対応手話 */
type CorrespondingSignLanguage = CommunicationMethod;
/** 発音 */
type Pronunciation = CommunicationMethod;

/**
 * アクタータイプの定義
 */
export class ActorType {
  public typeName = '';
  public type = '';

  static toActorTypeName(type: ActorTypeNames): string {
    return this.getInstanceByName(type).typeName;
  }

  static getInstanceByName(name: ActorTypeNames): ActorType {
    switch (name) {
      case 'MultiDeaf':
        return new MultiDeaf(); //マルチデフ
      case 'IdenDeaf':
        return new IdenDeaf(); //アイデンろう者
      case 'CorrespondingHardHearing':
        return new CorrespondingHardHearing(); //対応難聴者
      case 'IdenHardHearing':
        return new IdenHardHearing(); //アイデン難聴者
      case 'MultiListener':
        return new MultiListener(); //マルチ聴者
      case 'CorrespondingListener':
        return new CorrespondingListener(); //対応聴者
      case 'Listener':
        return new Listener(); //一般聴者
    }
  }

  static getMoreWeak(exp: CommunicationMethod, read: CommunicationMethod) {
    if (priorityComminicationMethod(exp) > priorityComminicationMethod(read)) {
      return read;
    } else if (priorityComminicationMethod(exp) < priorityComminicationMethod(read)) {
      return exp;
    } else {
      // 等しいならどっちでも
      return exp;
    }
  }

  static getInstance(defness: Deafness, isTeacher: boolean, signLanguage: SignLanguage, csl: CorrespondingSignLanguage, pronunciation: Pronunciation) {
    // 読み取りと表出で分けていたが、仕様変更
    return ActorType.getInstanceByWeak(defness, isTeacher, signLanguage, csl, pronunciation);
  }

  /**
   * コミュニケーション手段によってアクタータイプを判別する
   * @param signLanguage 日本手話
   * @param csl 日本語対応手話
   * @param pronunciation 発話
   * @param rw 読み書き
   */
  static getInstanceByWeak(defness: Deafness, isTeacher: boolean, signLanguage: SignLanguage, csl: CorrespondingSignLanguage, pronunciation: Pronunciation): ActorType {
    console.log('defness', defness, 'isTeacher', isTeacher, 'signLanguage', signLanguage, 'csl', csl, 'pronunciation', pronunciation);
    if (defness === 'Deaf' || defness === 'HardHearing') {
      // DEAF
      if (MultiDeaf.judgeType(signLanguage, csl, pronunciation)) {
        return new MultiDeaf();
      } else if (IdenDeaf.judgeType(isTeacher, signLanguage, csl, pronunciation)) {
        return new IdenDeaf();
      } else if (CorrespondingHardHearing.judgeType(isTeacher, signLanguage, csl, pronunciation)) {
        return new CorrespondingHardHearing();
      } else if (IdenHardHearing.judgeType(isTeacher, signLanguage, csl, pronunciation)) {
        return new IdenHardHearing();
      } else {
        throw new AssertionError({
          message: `ありえないアクタータイプです,defness:${defness},isTeacher:${isTeacher},signLanguage:${signLanguage},csl:${csl},pronunciation:${pronunciation}`,
        });
      }
    } else {
      // 聴者
      if (MultiListener.judgeType(isTeacher, signLanguage, csl, pronunciation)) {
        return new MultiListener();
      } else if (CorrespondingListener.judgeType(isTeacher, signLanguage, csl, pronunciation)) {
        return new CorrespondingListener();
      } else if (Listener.judgeType(isTeacher, signLanguage, csl, pronunciation)) {
        return new Listener();
      } else {
        throw new AssertionError({
          message: `ありえないアクタータイプです,defness:${defness},isTeacher:${isTeacher},signLanguage:${signLanguage},csl:${csl},pronunciation:${pronunciation}`,
        });
      }
    }
  }
}

/**マルチデフ*/
class MultiDeaf extends ActorType {
  constructor() {
    super();
    this.type = 'MultiDeaf';
    this.typeName = 'マルチデフ';
  }
  static judgeType(signLanguage: SignLanguage, csl: CorrespondingSignLanguage, pronunciation: Pronunciation): boolean {
    return signLanguage === 'Fluently' && csl === 'Fluently' && (pronunciation === 'Fluently' || pronunciation === 'CanBeUsed');
  }
}

/** アイデンろう者*/
class IdenDeaf extends ActorType {
  constructor() {
    super();
    this.type = 'IdenDeaf';
    this.typeName = 'アイデンろう者';
  }

  static judgeType(isTeacher: boolean, signLanguage: SignLanguage, csl: CorrespondingSignLanguage, pronunciation: Pronunciation): boolean {
    const signLanguageIsPositive = signLanguage === 'Fluently' || signLanguage === 'CanBeUsed';
    const correspondingSingLangIsNotPositive = csl === 'CanBeUsed' || csl === 'HardlyUsable' || csl === 'CanNot' || csl === 'DoNotWantTo';
    const pronunciationIsPositive = pronunciation === 'Fluently' || pronunciation === 'CanBeUsed';
    const pronunciationIsNagative = pronunciation === 'HardlyUsable' || pronunciation === 'CanNot' || pronunciation === 'DoNotWantTo';

    /**アイデンろう者判定 */
    const isIdenDeaf =
      signLanguageIsPositive && // 日本手話にポジティブ
      correspondingSingLangIsNotPositive && //対応手話にはややネガティブ
      pronunciationIsPositive; // 発話に前向き

    /**手話で教えたいアイデンろう者判定(先生のみ) */
    const isTeacherIdenDeafExpectTeacheSignLanguage =
      isTeacher === true && // 先生
      signLanguageIsPositive && // 日本手話にポジティブ
      correspondingSingLangIsNotPositive && //対応手話にはややネガティブ
      pronunciationIsNagative; // 発話にネガティブ
    return isIdenDeaf || isTeacherIdenDeafExpectTeacheSignLanguage;
  }
}

/** 対応難聴者 */
class CorrespondingHardHearing extends ActorType {
  constructor() {
    super();
    this.type = 'CorrespondingHardHearing';
    this.typeName = '対応難聴者';
  }

  static judgeType(isTeacher: boolean, signLanguage: SignLanguage, csl: CorrespondingSignLanguage, pronunciation: Pronunciation): boolean {
    const signLanguageIsNegative = signLanguage === 'CanBeUsed' || signLanguage === 'HardlyUsable' || signLanguage === 'CanNot' || signLanguage === 'DoNotWantTo';
    const cslIsPositive = csl === 'Fluently' || csl === 'CanBeUsed';
    const pronunciationIsPositive = pronunciation === 'Fluently' || pronunciation === 'CanBeUsed';
    const pronunciationIsNagative = pronunciation === 'HardlyUsable' || pronunciation === 'CanNot' || pronunciation === 'DoNotWantTo';

    /** 対応難聴者判定 */
    const isCorrespondingHardHearing = signLanguageIsNegative && cslIsPositive && pronunciationIsPositive;

    /** 手話で教えたい対応難聴者(先生のみ) */
    const isCorrespondingHardHearingExpectTeacheSignLanguage = isTeacher === true && signLanguageIsNegative && cslIsPositive && pronunciationIsNagative;

    return isCorrespondingHardHearing || isCorrespondingHardHearingExpectTeacheSignLanguage;
  }
}

/** アイデン難聴者 */
class IdenHardHearing extends ActorType {
  constructor() {
    super();
    this.type = 'IdenHardHearing';
    this.typeName = 'アイデン難聴者';
  }
  static judgeType(isTeacher: boolean, signLanguage: SignLanguage, csl: CorrespondingSignLanguage, pronunciation: Pronunciation): boolean {
    const signLanguageIsVeryNegative = signLanguage === 'HardlyUsable' || signLanguage === 'CanNot' || signLanguage === 'DoNotWantTo';
    const cslIsVeryNegative = csl === 'HardlyUsable' || csl === 'CanNot' || csl === 'DoNotWantTo';
    return signLanguageIsVeryNegative && cslIsVeryNegative;
  }
}

/** マルチ聴者 */
class MultiListener extends ActorType {
  constructor() {
    super();
    this.type = 'MultiListener';
    this.typeName = 'マルチ聴者';
  }

  static judgeType(isTeacher: boolean, signLanguage: SignLanguage, csl: CorrespondingSignLanguage, pronunciation: Pronunciation): boolean {
    const signLanguageIsVeryUsefull = signLanguage === 'Fluently';
    const signLanguageIsUsefull = signLanguage === 'Fluently' || signLanguage === 'CanBeUsed';

    const cslIsUsefull = csl === 'Fluently' || csl === 'CanBeUsed';
    const cslIsNegative = csl === 'HardlyUsable' || csl === 'CanNot' || csl === 'DoNotWantTo';
    // マルチ聴者判定
    const multiListner = signLanguageIsVeryUsefull && cslIsUsefull;
    // (日本手話聴者)だが、この人は日本語対応手話もできると考え「マルチ聴者」として判定
    const multiCorrespondingListener = signLanguageIsUsefull && cslIsNegative;
    return multiListner || multiCorrespondingListener;
  }
}

/** 対応聴者 */
class CorrespondingListener extends ActorType {
  constructor() {
    super();
    this.type = 'CorrespondingListener';
    this.typeName = '対応聴者';
  }

  static judgeType(isTeacher: boolean, signLanguage: SignLanguage, csl: CorrespondingSignLanguage, pronunciation: Pronunciation): boolean {
    const signLanguageIsNegative = signLanguage === 'CanBeUsed' || signLanguage === 'CanNot' || signLanguage === 'HardlyUsable' || signLanguage === 'DoNotWantTo';
    const cslIsPositive = csl === 'Fluently' || csl === 'CanBeUsed';
    return signLanguageIsNegative && cslIsPositive;
  }
}
/** 一般聴者 */
class Listener extends ActorType {
  constructor() {
    super();
    this.type = 'Listener';
    this.typeName = '一般聴者';
  }
  static judgeType(isTeacher: boolean, signLanguage: SignLanguage, csl: CorrespondingSignLanguage, pronunciation: Pronunciation): boolean {
    const signLanguageIsNegative = signLanguage === 'CanNot' || signLanguage === 'HardlyUsable' || signLanguage === 'DoNotWantTo';
    const cslIsNegative = csl === 'CanNot' || csl === 'HardlyUsable' || csl === 'DoNotWantTo';
    return signLanguageIsNegative && cslIsNegative;
  }
}

export const toJaFromDeffness = (cell: string) => {
  let ret = cell;
  if (cell === 'Listener') {
    ret = '聴者';
  }
  if (cell === 'HardHearing') {
    ret = '難聴者';
  }
  if (cell === 'Deaf') {
    ret = 'ろう者';
  }
  return ret;
};

export const toJaFromActorType = (cell: string) => {
  let ret = cell;

  if (cell === 'MultiDeaf') {
    ret = 'マルチデフ';
  }
  if (cell === 'IdenDeaf') {
    ret = 'アイデンろう者';
  }
  if (cell === 'CorrespondingHardHearing') {
    ret = '対応難聴者';
  }
  if (cell === 'IdenHardHearing') {
    ret = 'アイデン難聴者';
  }
  if (cell === 'MultiListener') {
    ret = 'マルチ聴者';
  }
  if (cell === 'CorrespondingListener') {
    ret = '対応聴者';
  }
  if (cell === 'Listener') {
    ret = '一般聴者';
  }
  return ret;
};
export const toJaFromListenerType = (cell: string) => {
  let ret = cell;
  if (cell === 'Fluently') {
    ret = '得意意識がある';
  }
  if (cell === 'CanBeUsed') {
    ret = 'どちらかといえば得意意識がある';
  }
  if (cell === 'HardlyUsable') {
    ret = 'どちらかといえば苦手意識がある';
  }
  if (cell === 'HardHearing') {
    ret = ':';
  }
  if (cell === 'CanNot') {
    ret = 'できない';
  }
  if (cell === 'DoNotWantTo') {
    ret = 'したくない';
  }
  return ret;
};
